
import * as React from "react"
import { cn } from "@/lib/utils"
import { Input } from "@/components/ui/input"
import { Eye, EyeOff } from "lucide-react"
import { Button } from "./button"

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  showPasswordState?: [boolean, React.Dispatch<React.SetStateAction<boolean>>]
  className?: string
}

export const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, showPasswordState, ...props }, ref) => {
    // Use external state if provided, otherwise create internal state
    const [showPassword, setShowPassword] = showPasswordState || React.useState(false)

    const togglePasswordVisibility = () => {
      setShowPassword(prev => !prev)
    }

    return (
      <div className="relative">
        <Input
          type={showPassword ? "text" : "password"}
          className={cn("pr-10", showPassword && "text-mono-platinum", className)}
          ref={ref}
          {...props}
        />
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={togglePasswordVisibility}
          className={cn(
            "absolute right-0 top-0 h-full px-3 py-2 bg-transparent hover:bg-transparent transition-colors duration-200",
            showPassword 
              ? "text-mono-platinum hover:text-mono-seasalt" 
              : "text-mono-slateGray hover:text-mono-platinum"
          )}
        >
          {showPassword ? (
            <Eye className="h-4 w-4" aria-hidden="true" />
          ) : (
            <EyeOff className="h-4 w-4" aria-hidden="true" />
          )}
          <span className="sr-only">
            {showPassword ? "Hide password" : "Show password"}
          </span>
        </Button>
      </div>
    )
  }
)

PasswordInput.displayName = "PasswordInput"
